import ApiConstants from '../../constants/ApiConstants';
import xhr from './xhr';

const AuthApiUtils = {
  loginWithEmail(email, password, country_code, ip, locale) {
    return xhr(ApiConstants.LoginWithEmail, {
      method: 'post',
      body: JSON.stringify({
        email,
        password,
        country_code,
        ip,
        locale,
      }),
    });
  },

  signup(params) {
    return xhr(ApiConstants.SignupWithEmail, {
      method: 'post',
      body: JSON.stringify(params),
    });
  },

  changePassword(oldPassword, newPassword, confirmPassword) {
    return xhr(ApiConstants.ChangePassword, {
      method: 'put',
      body: JSON.stringify({
        old_password: oldPassword,
        new_password: newPassword,
        confirm_password: confirmPassword,
      }),
    });
  },

  sendResetPasswordLink(email) {
    return xhr(ApiConstants.SendResetPasswordLink, {
      method: 'post',
      body: JSON.stringify({ email }),
    });
  },

  resetPassword(new_password, confirm_password, reset_password_token) {
    return xhr(ApiConstants.ResetPassword, {
      method: 'post',
      body: JSON.stringify({
        new_password,
        confirm_password,
        reset_password_token,
      }),
    });
  },

  /**
   * Refreshes the access token using a refresh token
   * @param {string} refreshToken - The refresh token
   * @returns {Promise<{accessToken: string, tokenType: string, expiresIn: number}>}
   */
  refreshToken(refreshToken) {
    return xhr(ApiConstants.RefreshToken, {
      method: 'post',
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
  },

  /**
   * Logs out by revoking the refresh token
   * @param {string} refreshToken - The refresh token to revoke
   */
  logoutWithToken(refreshToken) {
    return xhr(ApiConstants.LogoutWithToken, {
      method: 'delete',
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
  },

  /**
   * Logs out from all sessions by revoking all refresh tokens
   */
  logoutAll() {
    return xhr(ApiConstants.LogoutAll, {
      method: 'delete',
    });
  },
};

export default AuthApiUtils;
